'use client'

import { useSearchParams } from 'next/navigation'
import { COLOR_SEARCH_PARAM } from 'product/constants/constants'
import { useEffect } from 'react'
import type { Color, FullProduct } from '../../types/FullProduct'

interface UpdatePdpUrlProps {
	readonly product: FullProduct
	readonly selectedColor: Color
}

export function UpdatePdpUrl({
	product,
	selectedColor,
}: UpdatePdpUrlProps): null {
	const searchParams = useSearchParams()

	useEffect(() => {
		if (product.url) {
			const url = new URL(window.location.href)
			const pdpUrl = new URL(product.url, url.origin)
			const params = new URLSearchParams(searchParams)

			if (selectedColor.id !== params.get(COLOR_SEARCH_PARAM)) {
				params.delete(COLOR_SEARCH_PARAM)
			}

			pdpUrl.search = params.toString()

			if (pdpUrl.href !== url.href) {
				window.history.replaceState(null, '', pdpUrl.href)
			}
		}
	}, [product, searchParams])

	return null
}
